"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "blufi": {
    "e6eaf400": [{
      "hkey": "4ef69a91",
      "slug": "blufi",
      "name": "Blufi",
      "primary": true,
      "skipSearch": false
    }],
    "alleri": [{
      "hkey": "4ef69a91",
      "slug": "blufi",
      "name": "Blufi",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "a915fcbf": [{
      "hkey": "4ef69a91",
      "slug": "blufi",
      "name": "Blufi",
      "primary": true,
      "skipSearch": false
    }],
    "beniscichi": [{
      "hkey": "4ef69a91",
      "slug": "blufi",
      "name": "Blufi",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "a09241d7": [{
      "hkey": "4ef69a91",
      "slug": "blufi",
      "name": "Blufi",
      "primary": true,
      "skipSearch": false
    }],
    "casalgiordano": [{
      "hkey": "4ef69a91",
      "slug": "blufi",
      "name": "Blufi",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "a2141bcd": [{
      "hkey": "4ef69a91",
      "slug": "blufi",
      "name": "Blufi",
      "primary": true,
      "skipSearch": false
    }],
    "collesani": [{
      "hkey": "4ef69a91",
      "slug": "blufi",
      "name": "Blufi",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "01638dda": [{
      "hkey": "996c9a44",
      "slug": "giaia",
      "name": "Giaia",
      "primary": true,
      "skipSearch": false
    }],
    "giaia-inferiore": [{
      "hkey": "996c9a44",
      "slug": "giaia",
      "name": "Giaia",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "9a83c489": [{
      "hkey": "4ef69a91",
      "slug": "blufi",
      "name": "Blufi",
      "primary": true,
      "skipSearch": false
    }],
    "lupi": [{
      "hkey": "4ef69a91",
      "slug": "blufi",
      "name": "Blufi",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "ce9b96a3": [{
      "hkey": "4ef69a91",
      "slug": "blufi",
      "name": "Blufi",
      "primary": true,
      "skipSearch": false
    }],
    "macelli": [{
      "hkey": "4ef69a91",
      "slug": "blufi",
      "name": "Blufi",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "aebbc1bc": [{
      "hkey": "4ef69a91",
      "slug": "blufi",
      "name": "Blufi",
      "primary": true,
      "skipSearch": false
    }],
    "oliva": [{
      "hkey": "4ef69a91",
      "slug": "blufi",
      "name": "Blufi",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;